import { Grid } from "@mui/material";
import { ManagementTableHeader } from "../components/Management/ManagementTableHeader";
import { CreateEditModal } from "../components/Management/components/CreateEditModalBox";
import { InviteModal } from "../components/Management/components/InviteModalBox";
import { ManagementType, SortDirection } from "types/common";
import { Clinician } from "types/Clinician";
import { userOperations, USER_GROUPS } from "constants/roles";
import { useEffect, useMemo, useState } from "react";
import { ManagementTableRow } from "../components/Management/ManagementTableRow";
import { Loading } from "../../../components/Loading/Loading";
import { useAppSelector, useAppDispatch } from "hooks/reduxHooks";
import {
  selectCurrentClinicianList,
  selectCurrentClinicianPatients,
} from "store/ClinicianStore/selectors";
import { InviteResultModal } from "pages/auth/InviteResultModal";
import { selectCurrentClinicPatientsList } from "store/PatientStore/selectors";
import { Patient } from "types/Patient";
import { FilterModal } from "components/FilterModal/FilterModal";
import { FilterType } from "constants/types";
import HeaderModalsByTab from "../components/Management/components/HeaderModalsByTab";
import HeaderActionsByTab from "../components/Management/components/HeaderActionsByTab";
import PaginationByRole from "../components/Management/components/PaginationByRole";
import {
  getClinicianPatientsList,
  getClinicRecoveryTemplates,
} from "store/ClinicianStore/actions";

type Props = {
  onClick?: any;
  onClickClinicianPatients?: any;
  sortConfig: any;
  onClickClinicPatients: any;
  currentClinician: Clinician;
  managementType?: ManagementType;
  clinicianPatientsLoading: any;
  clinicPatientsLoading: any;
  clinicPatientsPage: number;
  clinicPatientsTotalPages: number;
  onClinicPatientsPageChange: (event: React.ChangeEvent<unknown>, page: number) => void;
  clinicianPatientsPage: number;
  clinicianPatientsTotalPages: number;
  onClinicianPatientsPageChange: (event: React.ChangeEvent<unknown>, page: number) => void;
  usersPage: number;
  usersTotalPages: number;
  onUsersPageChange: (event: React.ChangeEvent<unknown>, page: number) => void;
};

export const ContainerForCliniciansOtherRoles = ({
  onClick,
  onClickClinicianPatients,
  onClickClinicPatients,
  sortConfig,
  currentClinician,
  managementType,
  clinicianPatientsLoading,
  clinicPatientsLoading,
  clinicPatientsPage,
  clinicPatientsTotalPages,
  onClinicPatientsPageChange,
  clinicianPatientsPage,
  clinicianPatientsTotalPages,
  onClinicianPatientsPageChange,
  usersPage,
  usersTotalPages,
  onUsersPageChange,
}: Props) => {
  const dispatch = useAppDispatch();
  const [openCreateEditModal, setOpenCreateEditModal] =
    useState<boolean>(false);
  const [openInviteModal, setOpenInviteModal] = useState<boolean>(false);
  const currentClinicianList: Clinician[] | undefined = useAppSelector(
    selectCurrentClinicianList
  );

  const currentClinicianPatientsList: Patient[] | undefined = useAppSelector(
    selectCurrentClinicianPatients
  );
  const currentClinicPatientsList: Patient[] | undefined = useAppSelector(
    selectCurrentClinicPatientsList
  );

  const [dataList, setDataList] = useState<Patient[] | Clinician[] | []>([]);
  const [createEditOperation, setCreateEditOperation] =
    useState<userOperations>(userOperations.CREATE);
  const openCreateEditModalWithOperation = (
    isCreateEditModalEnabled: boolean,
    operationType: userOperations
  ) => {
    setCreateEditOperation(operationType);
    setOpenCreateEditModal(isCreateEditModalEnabled);
  };
  const [open, setOpen] = useState(false);
  const [isError, setError] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState<boolean>(false);
  const [openInviteFilterModal, setOpenInviteFilterModal] =
    useState<boolean>(false);
  const isPatientCare = managementType === ManagementType.PATIENT_CARE;
  const isPatientList = managementType === ManagementType.PATIENT;
  const isUserList = managementType === ManagementType.USER;

  const getTitleByRole = () => {
    if (managementType == ManagementType.USER) {
      return "Users List";
    } else if (managementType == ManagementType.PATIENT) {
      if (currentClinician?.role?.includes(USER_GROUPS.CLINIC_ASSISTANT)) {
        return "Patient Team Lead Assignment";
      } else if (
        currentClinician?.role?.includes(USER_GROUPS.CLINIC_TEAM_LEAD)
      ) {
        return "Patient Team Assignment";
      }
    } else if (managementType == ManagementType.PATIENT_CARE) {
      return "My Assigned Patients";
    } else {
      return "";
    }
  };

  useEffect(() => {
    getDataByType();
  }, [
    currentClinicianList,
    currentClinicianPatientsList,
    currentClinicPatientsList,
  ]);

  const getDataByType = () => {
    const leadAndAssistantRoles = [USER_GROUPS.CLINIC_ASSISTANT];
    const isAssistant = currentClinician?.role?.some((role) =>
      leadAndAssistantRoles.includes(role)
    );

    const isLead = currentClinician?.role?.includes(
      USER_GROUPS.CLINIC_TEAM_LEAD
    );

    const isClinician = currentClinician?.role?.includes(USER_GROUPS.CLINICIAN);
    console.log({
      isUserList,
      currentClinicianList,
      isAssistant,
      isPatientList,
      isLead,
      isClinician,
      isPatientCare,
      currentClinicianPatientsList,
    });
    if (isUserList && currentClinicianList) {
      return setDataList(currentClinicianList);
    }

    if (isAssistant && isPatientList) {
      return setDataList(currentClinicPatientsList);
    }

    if (isLead && isPatientList && currentClinicPatientsList) {
      return setDataList(currentClinicPatientsList);
    }

    if (isClinician && isPatientCare && currentClinicianPatientsList) {
      return setDataList(currentClinicianPatientsList);
    }
  };

  const getLoading = () => {
    if (managementType === ManagementType.PATIENT_CARE) {
      return clinicianPatientsLoading || clinicPatientsLoading;
    }
    if (managementType === ManagementType.PATIENT) {
      return clinicPatientsLoading;
    }
    return clinicianPatientsLoading;
  };

  const sortedDataList = useMemo(() => {
    if (!sortConfig?.sortBy) {
      return dataList;
    }

    if (sortConfig.sortBy === "name") {
      return [...dataList].sort((a: any, b: any) => {
        const firstNameA = a.profileInfo?.firstName || a.firstName || "";
        const lastNameA = a.profileInfo?.lastName || a.lastName || "";
        const firstNameB = b.profileInfo?.firstName || b.firstName || "";
        const lastNameB = b.profileInfo?.lastName || b.lastName || "";

        const nameA = `${firstNameA} ${lastNameA}`.toLowerCase();
        const nameB = `${firstNameB} ${lastNameB}`.toLowerCase();

        if (sortConfig.sortDirection === SortDirection.asc) {
          return nameA.localeCompare(nameB);
        }
        return nameB.localeCompare(nameA);
      });
    }

    if (sortConfig.sortBy === "assignedTeamMembers") {
      return [...dataList].sort((a: any, b: any) => {
        const firstMemberA = a.assignedTeamMembers?.[0];
        const firstMemberB = b.assignedTeamMembers?.[0];

        // Handle cases where one or both don't have team members
        const hasA = !!firstMemberA;
        const hasB = !!firstMemberB;
        if (!hasA && !hasB) return 0;
        if (!hasA) return sortConfig.sortDirection === SortDirection.asc ? 1 : -1;
        if (!hasB) return sortConfig.sortDirection === SortDirection.asc ? -1 : 1;

        const firstNameA = firstMemberA?.profileInfo?.firstName || firstMemberA?.firstName || "";
        const lastNameA = firstMemberA?.profileInfo?.lastName || firstMemberA?.lastName || "";
        const firstNameB = firstMemberB?.profileInfo?.firstName || firstMemberB?.firstName || "";
        const lastNameB = firstMemberB?.profileInfo?.lastName || firstMemberB?.lastName || "";

        const nameA = `${firstNameA} ${lastNameA}`.toLowerCase();
        const nameB = `${firstNameB} ${lastNameB}`.toLowerCase();

        if (sortConfig.sortDirection === SortDirection.asc) {
          return nameA.localeCompare(nameB);
        }
        return nameB.localeCompare(nameA);
      });
    }

    if (sortConfig.sortBy === "assignedTeamLead") {
      return [...dataList].sort((a: any, b: any) => {
        const firstLeadA = a.assignedTeamLead?.[0];
        const firstLeadB = b.assignedTeamLead?.[0];

        // Handle cases where one or both don't have team lead
        const hasA = !!firstLeadA;
        const hasB = !!firstLeadB;
        if (!hasA && !hasB) return 0;
        if (!hasA) return sortConfig.sortDirection === SortDirection.asc ? 1 : -1;
        if (!hasB) return sortConfig.sortDirection === SortDirection.asc ? -1 : 1;

        const firstNameA = firstLeadA?.profileInfo?.firstName || firstLeadA?.firstName || "";
        const lastNameA = firstLeadA?.profileInfo?.lastName || firstLeadA?.lastName || "";
        const firstNameB = firstLeadB?.profileInfo?.firstName || firstLeadB?.firstName || "";
        const lastNameB = firstLeadB?.profileInfo?.lastName || firstLeadB?.lastName || "";

        const nameA = `${firstNameA} ${lastNameA}`.toLowerCase();
        const nameB = `${firstNameB} ${lastNameB}`.toLowerCase();

        if (sortConfig.sortDirection === SortDirection.asc) {
          return nameA.localeCompare(nameB);
        }
        return nameB.localeCompare(nameA);
      });
    }

    return dataList;
  }, [dataList, sortConfig]);

  useEffect(() => {
    dispatch(getClinicianPatientsList(currentClinician._id));
    dispatch(getClinicRecoveryTemplates(currentClinician.clinicId));
  }, []);

  return (
    <>
      <Grid
        container
        style={{ marginBottom: 18, justifyContent: "space-between" }}
      >
        <Grid item ml={6} p={0} m={0}>
          <Grid
            sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
          >
            <h2 style={{ marginRight: 12 }}>{getTitleByRole()}</h2>
            <HeaderModalsByTab
              managementType={managementType}
              setOpenFilterModal={setOpenFilterModal}
              currentClinician={currentClinician}
              setOpenInviteFilterModal={setOpenInviteFilterModal}
              openInviteFilterModal={openInviteFilterModal}
            />
          </Grid>
        </Grid>
        <Grid item ml={6} p={0} m={0}>
          <Grid container gap={2}>
            <HeaderActionsByTab
              managementType={managementType}
              openCreateEditModalWithOperation={
                openCreateEditModalWithOperation
              }
              currentClinician={currentClinician}
              setOpenInviteModal={setOpenInviteModal}
              openFilterModal={openFilterModal}
              setOpenFilterModal={setOpenFilterModal}
            />
          </Grid>
        </Grid>
      </Grid>
      {isPatientCare && (
        <FilterModal
          isEnabled={openFilterModal}
          setIsEnabled={setOpenFilterModal}
          operation={FilterType.PATIENT_FILTER}
          currentClinician={currentClinician}
        />
      )}
      <ManagementTableHeader
        onClick={onClick}
        onClickClinicianPatients={onClickClinicianPatients}
        onClickClinicPatients={onClickClinicPatients}
        sortConfig={sortConfig}
        managementType={managementType}
      />
      <div
        className="w-full min-h-[200px] flex flex-col overflow-y-hidden space-y-[5px] relative"
        style={
          !currentClinician?.role?.includes(USER_GROUPS.CLINICIAN) &&
          isPatientCare
            ? { pointerEvents: "none" }
            : {}
        }
      >
        {!sortedDataList || sortedDataList.length === 0 ? (
          <div style={{ marginTop: "5%", textAlign: "center", color: "#999" }}>
            No data available
          </div>
        ) : (
          sortedDataList.map((user: any, index) => (
            <ManagementTableRow
              key={index}
              user={user}
              managementType={managementType}
              openCreateEditModalOperation={openCreateEditModalWithOperation}
            />
          ))
        )}
        <Loading loading={getLoading()} states={dataList} />
      </div>
      <PaginationByRole
        currentClinician={currentClinician}
        managementType={managementType}
        clinicPatientsPage={clinicPatientsPage}
        clinicPatientsTotalPages={clinicPatientsTotalPages}
        onClinicPatientsPageChange={onClinicPatientsPageChange}
        clinicPatientsLoading={clinicPatientsLoading}
        clinicianPatientsPage={clinicianPatientsPage}
        clinicianPatientsTotalPages={clinicianPatientsTotalPages}
        onClinicianPatientsPageChange={onClinicianPatientsPageChange}
        clinicianPatientsLoading={clinicianPatientsLoading}
        usersPage={usersPage}
        usersTotalPages={usersTotalPages}
        onUsersPageChange={onUsersPageChange}
        usersLoading={clinicianPatientsLoading}
      />
      {
        <CreateEditModal
          isEnabled={openCreateEditModal}
          setIsEnabled={setOpenCreateEditModal}
          operation={createEditOperation}
          setOpen={setOpen}
          setError={setError}
        />
      }
      {
        <InviteModal
          isEnabled={openInviteModal}
          setIsEnabled={setOpenInviteModal}
        />
      }
      {<InviteResultModal open={open} setOpen={setOpen} isError={isError} />}
    </>
  );
};
